













































































import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import appModule from './model/store/modules/app-module';
import userModule from './model/store/modules/user-module';
import contentsModule from '@/model/store/modules/contents-module';
import infomationModule from '@/model/store/modules/infomation-module';
import viewerService from '@/model/services/viewer-service';
import contentsService from '@/model/services/contents-service';
import userService from '@/model/services/user-service';
import {QueryInterface} from '@/model/interfaces/query-interface';
import {GlobalConstants} from '@/common/constants';
import {GlobalAuthority, AuthorityNum} from '@/common/authority';
import goTo from 'vuetify/es5/services/goto';
import _ from 'lodash';

@Component({
  components: {
  }
})
export default class TitleBar extends Vue {
  private drawer: boolean = false;
  private isOffset: boolean = false;
  private isOnChangeRoute: boolean = false;

  /** Computed **/
  get userName() {
    return userModule.userName;
  }

  get userId() {
    return userModule.userId;
  }

  get menuInfo() {
    return appModule.menuInfo;
  }

  get innerYOffset() {
    return this.isOffset ? 0 : contentsModule.innerYOffset;
  }

  get innerWidth() {
    return contentsModule.innerWidth;
  }

  get menu() {
    const menu = _.filter(GlobalConstants.MENU,
                (item: { TITLE: string, ROUTE: string, ADMIN: boolean }) =>
                !item.ADMIN || item.ADMIN && this.isAuthorityNumber < this.Learner );
    return menu;
  }

  get isAuthorityNumber() {
    return userService.isAuthorityNumber(userModule.type);
  }

  get Learner() {
    return AuthorityNum.Learner;
  }

  get infomations() {
    return infomationModule.infomationInfo;
  }

  get meta() {
    return appModule.meta;
  }

  get text() {
    return {
      loginpath: GlobalConstants.LOGIN.PATH,
      name: GlobalConstants.TEXT.DIGITALBADGE.NAME,
      getBadge: GlobalConstants.TEXT.DIGITALBADGE.GETBADGE,
      badgeType: GlobalConstants.TEXT.DIGITALBADGE.BADGETYPE,
      contents: GlobalConstants.TEXT.DIGITALBADGE.CONTENTS,
      publish: GlobalConstants.TEXT.DIGITALBADGE.PUBLISH,
      cool: GlobalConstants.TEXT.DIGITALBADGE.COOL,
      posts: GlobalConstants.TEXT.DIGITALBADGE.POSTS,
      title: GlobalConstants.TEXT.ACCOUNT.TITLE,
      logo: GlobalConstants.LOGO.SRC
    };
  }

  /** Methods **/
  private async homeBtn() {
    await appModule.requestCategoryInfo({
      q: appModule.searchKeyword !== '' ? appModule.searchKeyword : '',
      s: 0,
      o: 'dp'
    })
    .catch(err => {
      this.errorPropagation(err);
    });
    const token = appModule.token;
    const path = `/`;
    this.$router.push({ path: `${path}`}).catch(err => err);
    contentsModule.updatePanelNo(0);
  }

  private async onChangeContents(item: { TITLE: string, ROUTE: string }): Promise<void> {
    const token = appModule.token;
    let path = '';
    switch (item.ROUTE) {
      case 'account':
        path = `/account/${this.userId}`;
        break;
      case 'postcountmanage':
        path = `/postcountmanage/${this.userId}`;
        break;
      case 'categorymanage':
        path = `/categorymanage/${this.userId}`;
        break;
      case 'logout':
        appModule.startLoading();
        userModule.clearStrage();
        await appModule.requestLogoutInfo().catch(err => {
          this.errorPropagation(err);
        });
        path = this.text.loginpath;
        break;
      default: break;
    }
    if (this.$route.path !== path) {
      this.$router.push({ path: `${path}`});
    }
  }

  private onClickIsAside() {
    contentsModule.pushIsAside(!contentsModule.isAside);
  }

  private settingMeta(meta: any, path: any) {
    // OGP設定
    const ogp = appModule.meta;
    const target = this.$route.name === 'route-viewer' || this.$route.name === 'detail-viewer' || this.$route.name === 'about-viewer' || this.$route.name === 'menu-viewer';
    if (ogp.title) {
      const title = !target ? '福岡市南区大橋の美容室 chisei' : `${ogp.title} | 福岡市南区大橋の美容室 chisei`;
      document.title = title;
      document.querySelector('meta[property=\'og:title\']')?.setAttribute('content', title);
      document.querySelector('meta[name=\'twitter:title\']')?.setAttribute('content', title);
    }
    if (ogp.description) {
      const description = !target ? 'chiseiは福岡市南区大橋を拠点にしている美容室。' : ogp.description;
      document.querySelector('meta[name=\'description\']')?.setAttribute('content', description);
      document.querySelector('meta[property=\'og:description\']')?.setAttribute('content', description);
      document.querySelector('meta[name=\'twitter:description\']')?.setAttribute('content', description);
    }
    if (ogp.image) {
      const image = !target ? `${process.env.VUE_APP_BASE_URL}images/logo/logo.png` : ogp.image;
      document.querySelector('meta[property=\'og:image\']')?.setAttribute('content', image);
      document.querySelector('meta[name=\'twitter:image\']')?.setAttribute('content', image);
    }
    if (path) {
      document.querySelector('meta[property=\'og:url\']')?.setAttribute('content', `${process.env.VUE_APP_BASE_URL}${path.slice(1)}`);
    }

  }

  @Watch('meta', {deep: true})
  private onMeta() {
    if (this.isOnChangeRoute) {
      this.isOnChangeRoute = false;
      return false;
    }
    this.settingMeta(this.$route.meta, this.$route.path);
  }

  /** Watchers **/
  @Watch('$route')
  private async onChangeRoute(to: {path: string, name: string, meta: {title: string, desc: string}}, from: {path: string, name: string, meta: {title: string, desc: string}}): Promise<void> {
    this.isOnChangeRoute = true;
    if (to.name === 'account-viewer' || to.name === 'edit-viewer') {
      this.isOffset = true;
    } else {
      this.isOffset = false;
    }
    const func = _.debounce(() => {
      this.settingMeta(to.meta, to.path);
    }, 500);
    func();
  }

  @Watch('userId')
  private async onUserId(to: {path: string}, from: {path: string}): Promise<void> {
    if (userModule.userId !== '') {
    }
  }

  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

  /** LifeCycle **/
  private async mounted() {
    // 初期queryのtokenをセット
    const token = this.$route.query.token ?? userModule.apiToken;
    // appModule.initApp({ token: `${token}` });
    let query: QueryInterface = {};
    if (this.$route.query.cid) {
      query = {
        cid : +this.$route.query.cid
      };
      const cid = +this.$route.query.cid > 0 ? +this.$route.query.cid - 1 : null;
      contentsModule.updatePanelNo(cid);
    }
    this.$router.push({path: `${this.$route.path}`,
      query
    }).catch(err => err);
    userService.requestUserInfo();
    if (this.$route.name === 'account-viewer' || this.$route.name === 'edit-viewer') {
      this.isOffset = true;
    } else {
      this.isOffset = false;
    }

    // this.settingMeta(this.$route.meta, this.$route.path);

    await infomationModule.requestInfomationInfo(1);

    if (+this.$route.query.cid > 0) {
      const func = _.debounce(() => {
        goTo('.panel-header-' + (+this.$route.query.cid));
      }, 500);
      func();
    }
  }

}
